import { FC, useMemo } from 'react'
import { GridRenderCellParams } from '@microservices/wiskey-react-table-component'
import { Grid, Skeleton } from '@mui/material'

import { useAppSelector } from '@hooks'
import { renderJSValueCell, renderJSXValueCell } from '@helpers'
import { BIND_TYPE } from '@constants'
import { DateIntervalKey, TimeLineDTOType } from '@types'

type PinnedAggregationRowCellType = {
  params: GridRenderCellParams
  config?: TimeLineDTOType
}

export const PinnedAggregationRowCell: FC<PinnedAggregationRowCellType> = props => {
  const { params, config } = props

  const totalsRows = useAppSelector(state => state.timeLineGrid.totalsRows)

  const rowIndex = useMemo(
    () => totalsRows.findIndex(item => item.id === params.id),
    [totalsRows, params.id]
  )

  const value = useMemo(() => {
    const row = totalsRows[rowIndex]

    if (row[params.field as keyof DateIntervalKey]?.[0]?.isLoading) {
      return (
        <Skeleton sx={{ width: '60%', height: '60%', borderRadius: '4px' }} variant={'rounded'} />
      )
    }

    const srcObj = {
      row,
      cellValue: row[params.field as keyof DateIntervalKey]?.[0]?.value,
      columnKey: params.field,
    }

    if (config?.objectX.totalsRows[rowIndex].bindType === BIND_TYPE.JSX) {
      return renderJSXValueCell(config?.objectX.totalsRows[rowIndex].script, srcObj)
    }

    return renderJSValueCell(config?.objectX.totalsRows[rowIndex].script as string, srcObj)
  }, [totalsRows])

  return (
    <Grid alignItems='center' display='flex' height='100%' justifyContent='center' width='100%'>
      {value}
    </Grid>
  )
}
